import type { ReactNode } from 'react';
import { FullscreenButton } from './FullscreenButton.tsx';
import type { TurnKind } from './TurnBanner.tsx';

interface GameLayoutProps {
  top: ReactNode;
  board: ReactNode;
  bottom: ReactNode;
  panel: ReactNode;
  notice?: ReactNode;
  /** Colours the board frame: green on your turn, red when your king is in check. */
  turn?: TurnKind;
}

/**
 * Phones: opponent · board · you, with the buttons underneath.
 * Larger screens: the board takes the full height on the left; the player
 * cards, buttons and move list fill a column on its right (CSS grid areas).
 */
export function GameLayout({ top, board, bottom, panel, notice, turn }: GameLayoutProps) {
  return (
    <div className={`game${turn ? ` turn-${turn}` : ''}`}>
      <div className="game-board-col">
        {notice && <div className="game-notice">{notice}</div>}
        <div className="game-top">{top}</div>
        {board}
        <div className="game-bottom">{bottom}</div>
      </div>
      <aside className="card game-panel">
        <div className="panel-tools">
          <FullscreenButton />
        </div>
        {panel}
      </aside>
    </div>
  );
}
